import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const panelEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, OperationType>,
		Record<string, EntryPoint<any, any> | undefined>,
		{},
		{} | null
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/panel-system/dummy-entrypoint-component" */ './dummy-entrypoint-component'
			),
		{
			moduleId: 'panel-entrypoint-1',
		},
	),
	getPreloadProps: () => ({}),
});
